import React from 'react';

/**
 * Placeholder shield cuando no hay bandera (30×30).
 * Trazo y "?" más visibles; sin scale() para que el stroke no se vea fino.
 */
export default function NoFlagShield({ className }) {
  return (
    <svg
      className={className}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="rgba(255, 255, 255, 0.25)"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      {/* Escudo: trazo grueso, color suave tipo spec */}
      <path
        d="M15 2.8L5.8 7.35v9.4c0 5.35 4.05 10.1 9.2 12.45 5.15-2.35 9.2-7.1 9.2-12.45v-9.4L15 2.8z"
        stroke="rgba(255, 255, 255, 0.22)"
        strokeWidth="2.6"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
      />
      {/* "?" centrado ópticamente (ligero nudge derecha/abajo) */}
      <text
        x="15.35"
        y="15.85"
        textAnchor="middle"
        dominantBaseline="central"
        alignmentBaseline="central"
        stroke="rgba(255, 255, 255, 0.22)"
        strokeWidth="0.55"
        paintOrder="stroke fill"
        fontSize="12.5"
        fontWeight="800"
        fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        style={{
          textRendering: 'geometricPrecision',
          dominantBaseline: 'central',
          alignmentBaseline: 'central'
        }}
      >
        ?
      </text>
    </svg>
  );
}
